import { writable } from 'svelte/store';

const FortyDealsStore = writable();

export default FortyDealsStore;
